module.exports = __webpack_public_path__ + "img/Card_confidentiality.278303d7.png";